<template>
    <v-container fluid v-if="mezzo">
        <v-btn icon variant="text" class="mb-2" @click="tornaIndietro">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-row>
            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title class="d-flex align-center">
                        {{ mezzo.nome }}
                        <v-chip class="ml-3" size="small" :color="coloreStato(mezzo.stato)" variant="flat">
                            {{ etichettaStato(mezzo.stato) }}
                        </v-chip>
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" variant="text" prepend-icon="mdi-pencil"
                            @click="dialogModifica = true">
                            Modifica
                        </v-btn>
                    </v-card-title>
                    <v-card-subtitle>{{ mezzo.categoria }}</v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6"><strong>Codice:</strong> {{ mezzo.codice || '—' }}</v-col>
                            <v-col cols="6"><strong>Targa:</strong> {{ mezzo.targa || '—' }}</v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6"><strong>Marca:</strong> {{ mezzo.marca || '—' }}</v-col>
                            <v-col cols="6"><strong>Modello:</strong> {{ mezzo.modello || '—' }}</v-col>
                        </v-row>
                        <div class="mt-2" v-if="mezzo.descrizione"><strong>Descrizione:</strong>
                            {{ mezzo.descrizione }}</div>
                        <div class="mt-2" v-if="mezzo.note"><strong>Note:</strong> {{ mezzo.note }}</div>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Documenti
                        <v-spacer />
                        <v-file-input v-model="fileDocumento" label="Carica documento (PDF)" accept="application/pdf"
                            density="compact" hide-details style="max-width: 260px" prepend-icon="mdi-upload"
                            @update:model-value="caricaDocumento" />
                    </v-card-title>
                    <v-card-text>
                        <v-list v-if="mezzo.allegati && mezzo.allegati.length > 0">
                            <v-list-item v-for="a in mezzo.allegati" :key="a.id" :title="a.nomeOriginale"
                                prepend-icon="mdi-file-pdf-box" />
                        </v-list>
                        <span v-else class="text-medium-emphasis">Nessun documento caricato.</span>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Scadenze
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" color="primary" prepend-icon="mdi-plus"
                            @click="dialogNuova = true">
                            Nuova
                        </v-btn>
                    </v-card-title>
                    <v-list>
                        <v-list-item v-for="s in scadenze" :key="s.id" :title="s.tipoScadenzaMezzoNome"
                            :subtitle="descrizioneRiga(s)">
                            <template #prepend>
                                <v-chip size="small" :color="coloreRiga(s)" variant="flat">
                                    {{ etichettaRiga(s) }}
                                </v-chip>
                            </template>
                            <template #append v-if="puoScrivere">
                                <!-- Niente "Inizia": una scadenza mezzo non ha wizard di fermo. -->
                                <v-btn v-if="s.stato === 'Pianificata'" size="small" variant="text" color="primary"
                                    @click="apriCompletamento(s.id)">
                                    Completa
                                </v-btn>
                                <v-btn icon variant="text" size="small" title="Duplica" @click="duplicaScadenza(s)">
                                    <v-icon size="small">mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon variant="text" size="small" color="error" @click="chiediEliminazione(s)">
                                    <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="scadenze.length === 0">
                            <span class="text-medium-emphasis">Nessuna scadenza registrata.</span>
                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Dispositivi di sicurezza
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" color="primary" prepend-icon="mdi-plus"
                            @click="dialogNuovoDispositivo = true">
                            Nuovo
                        </v-btn>
                    </v-card-title>
                    <v-list>
                        <v-list-item v-for="d in dispositiviSicurezza" :key="d.id" :title="d.nome"
                            :subtitle="d.tipoDispositivoSicurezzaNome" :to="`/sicurezza/${d.id}`">
                            <template #append>
                                <v-chip v-if="d.contenutiScaduti > 0" size="small" color="error" variant="flat">
                                    {{ d.contenutiScaduti }} scadut{{ d.contenutiScaduti === 1 ? 'o' : 'i' }}
                                </v-chip>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="dispositiviSicurezza.length === 0">
                            <span class="text-medium-emphasis">Nessun dispositivo di sicurezza collegato.</span>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>

            <v-col cols="12" md="4">
                <v-card>
                    <v-card-title>QR code</v-card-title>
                    <v-card-text class="text-center">
                        <div id="area-stampa-qr">
                            <canvas ref="qrCanvas"></canvas>
                            <div class="mt-2 text-caption text-medium-emphasis">Se non riesci a scansionare,
                                copia il link:</div>
                            <div class="text-body-2">{{ urlPubblico }}</div>
                        </div>
                        <v-btn class="mt-3" variant="outlined" prepend-icon="mdi-printer" @click="stampa">
                            Stampa
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <dialog-mezzo v-model="dialogModifica" :mezzo="mezzo" @salvato="carica" />

        <dialog-nuova-scadenza-mezzo v-model="dialogNuova" :mezzo-id="id" @salvato="ricaricaScadenze" />

        <dialog-completa-scadenza-mezzo v-model="dialogCompletamento" :scadenza-mezzo-id="scadenzaSelezionataId"
            :mezzo-id="id" @completata="onScadenzaAggiornata" />

        <dialog-dispositivo-sicurezza v-model="dialogNuovoDispositivo" :mezzo-fisso="id"
            @salvato="ricaricaDispositiviSicurezza" />

        <v-dialog v-model="dialogElimina" max-width="420">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>La scadenza verrà rimossa.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
    <v-container v-else>
        <v-progress-circular indeterminate color="primary" />
    </v-container>
</template>

<script>
import QRCode from "qrcode";
import { upload_allegato_mezzo } from "@/api/api.allegati.js";
import DialogNuovaScadenzaMezzo from "@/components/scadenzeMezzo/DialogNuovaScadenzaMezzo.vue";
import DialogCompletaScadenzaMezzo from "@/components/scadenzeMezzo/DialogCompletaScadenzaMezzo.vue";
import DialogMezzo from "@/components/mezzi/DialogMezzo.vue";
import DialogDispositivoSicurezza from "@/components/sicurezza/DialogDispositivoSicurezza.vue";
import { coloreStato, etichettaStato } from "@/constants/statoMezzo.js";
import { coloreRiga, etichettaRiga } from "@/constants/statoScadenzaMezzo.js";

export default {
    name: "MezzoDettaglioPage",

    components: {
        DialogNuovaScadenzaMezzo,
        DialogCompletaScadenzaMezzo,
        DialogMezzo,
        DialogDispositivoSicurezza,
    },

    props: {
        id: { type: [String, Number], required: true },
    },

    data() {
        return {
            fileDocumento: null,
            dialogNuova: false,
            dialogCompletamento: false,
            dialogModifica: false,
            scadenzaSelezionataId: null,
            dialogElimina: false,
            scadenzaDaEliminare: null,
            dialogNuovoDispositivo: false,
        };
    },

    computed: {
        mezzo() {
            return this.$store.getters["mezzi/corrente"];
        },
        scadenze() {
            return this.$store.getters["scadenzeMezzo/lista"];
        },
        dispositiviSicurezza() {
            return this.$store.getters["dispositiviSicurezza/lista"];
        },
        ruolo() {
            return this.$store.getters["user/getRole"];
        },
        puoScrivere() {
            return this.ruolo === "SuperAdmin" || this.ruolo === "Admin" || this.ruolo === "Operatore";
        },
        urlPubblico() {
            return `${window.location.origin}/mezzi/${this.id}`;
        },
    },

    watch: {
        id: {
            immediate: true,
            handler() {
                this.carica();
            },
        },
    },

    methods: {
        tornaIndietro() {
            this.$router.push("/mezzi");
        },

        async carica() {
            try {
                await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
                await this.ricaricaScadenze();
                await this.ricaricaDispositiviSicurezza();
                await this.$nextTick();
                this.generaQr();
            } catch (error) {
                console.log(error);
            }
        },

        ricaricaScadenze() {
            return this.$store.dispatch("scadenzeMezzo/carica", { mezzoId: this.id });
        },

        ricaricaDispositiviSicurezza() {
            return this.$store.dispatch("dispositiviSicurezza/carica", { mezzoId: this.id });
        },

        generaQr() {
            if (!this.$refs.qrCanvas) return;
            QRCode.toCanvas(this.$refs.qrCanvas, this.urlPubblico, { width: 220 }, (err) => {
                if (err) console.log(err);
            });
        },

        stampa() {
            window.print();
        },

        async caricaDocumento(file) {
            if (!file) return;
            try {
                await upload_allegato_mezzo(this.id, file);
                await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
                this.fileDocumento = null;
            } catch (error) {
                console.log(error);
            }
        },

        apriCompletamento(scadenzaId) {
            this.scadenzaSelezionataId = scadenzaId;
            this.dialogCompletamento = true;
        },

        async onScadenzaAggiornata() {
            await this.ricaricaScadenze();
            await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
        },

        async duplicaScadenza(s) {
            try {
                await this.$store.dispatch("scadenzeMezzo/duplica", { id: s.id, mezzoId: this.id });
            } catch (error) {
                console.log(error);
            }
        },

        chiediEliminazione(s) {
            this.scadenzaDaEliminare = s;
            this.dialogElimina = true;
        },

        async confermaEliminazione() {
            try {
                await this.$store.dispatch("scadenzeMezzo/elimina", {
                    id: this.scadenzaDaEliminare.id,
                    mezzoId: this.id,
                });
                await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
            } catch (error) {
                console.log(error);
            }
            this.dialogElimina = false;
        },

        coloreStato,
        etichettaStato,
        coloreRiga,
        etichettaRiga,

        descrizioneRiga(s) {
            const data = s.stato === "Completata" ? s.dataCompletamento : s.dataPrevista;
            return data ? new Date(data).toLocaleDateString("it-IT") : "";
        },
    },
};
</script>
